import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import TextInput from "../../../components/InputFields/TextInput";
import { failed, success } from "../../../utils/Tostify";
import Loader from "../../../components/Loader/Loader";
import { updatePatientById } from "../../../api/patient";
import { formikAddInsurance } from "../Constant";
import DatePickerSelector from "../../../components/InputFields/DatePicker";
import moment from "moment";
import { useNavigate } from "react-router";

const AddInsurance = ({ toggleTab, patientDeatils }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);
  const navigate = useNavigate();

  const formik = useFormik({
    ...formikAddInsurance,
    onSubmit: async (values) => {
      const cleanedValues = { ...values };
      let payload = { insuranceDetails: cleanedValues };
      let res;
      try {
        setIsLoading(true);
        res = await updatePatientById({ payload, dispatch, token, patientId: patientDeatils._id });
        if (res?.status === "SUCCESS") {
          setIsLoading(false);
          navigate("/clinic/patient-profile", { state: { patientData: patientDeatils?._id } });
          success(res?.message);
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  useEffect(() => {
    if (patientDeatils?.insuranceDetails) {
      const insuranceDetails = patientDeatils.insuranceDetails;
      formik.setValues({
        beneficiaryName: insuranceDetails.beneficiaryName || "",
        company: insuranceDetails.company || "",
        policyNumber: insuranceDetails.policyNumber || "",
        groupNumber: insuranceDetails.groupNumber || "",
        planType: insuranceDetails.planType || "",
        effectiveDate: insuranceDetails.effectiveDate || "",
        alternateBeneficiaryName: insuranceDetails.alternateBeneficiaryName || "",
        alternateCompany: insuranceDetails.alternateCompany || "",
        alternatePolicyNumber: insuranceDetails.alternatePolicyNumber || "",
        alternateGroupNumber: insuranceDetails.alternateGroupNumber || "",
        alternatePlanType: insuranceDetails.alternatePlanType || "",
        alternateEffectiveDate: insuranceDetails.alternateEffectiveDate || ""
      });
    }
  }, [patientDeatils]);
  return (
    <div>
      {isLoading ? <Loader /> : null}
      <Form onSubmit={formik.handleSubmit}>
        <h6>Primary Insurance Details</h6>
        <Row>
          <Col lg={4} md={6}>
            <TextInput
              keyField="beneficiaryName"
              formik={formik}
              label="Beneficiary Name"
              type="text"
              value={formik.values.beneficiaryName}
              onChange={(e) => formik.setFieldValue("beneficiaryName", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6}>
            <TextInput
              keyField="company"
              formik={formik}
              label="Company"
              type="text"
              value={formik.values.company}
              onChange={(e) => formik.setFieldValue("company", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6}>
            <TextInput
              keyField="policyNumber"
              formik={formik}
              label="Policy Number"
              type="text"
              value={formik.values.policyNumber}
              onChange={(e) => formik.setFieldValue("policyNumber", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6}>
            <TextInput
              keyField="groupNumber"
              formik={formik}
              label="Group Number"
              type="text"
              value={formik.values.groupNumber}
              onChange={(e) => formik.setFieldValue("groupNumber", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6}>
            <TextInput
              keyField="planType"
              formik={formik}
              label="Plan Type"
              type="text"
              value={formik.values.planType}
              onChange={(e) => formik.setFieldValue("planType", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6} className="modal_pro_file ">
            <DatePickerSelector
              keyField="effectiveDate"
              formik={formik}
              required={false}
              label="Effective Date"
              type="date"
              value={formik.values.effectiveDate}
              DatePickerSelector
              minDate={""}
              maxDate={moment()}
              onChange={(e) =>
                formik.setFieldValue("effectiveDate", moment(e).format("MM-DD-YYYY"))
              }
            />
          </Col>
        </Row>

        <h6>Secondary Insurance Details</h6>
        <Row>
          <Col lg={4} md={6}>
            <TextInput
              keyField="alternateBeneficiaryName"
              formik={formik}
              required={false}
              label="Beneficiary Name"
              type="text"
              value={formik.values.alternateBeneficiaryName}
              onChange={(e) => formik.setFieldValue("alternateBeneficiaryName", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6}>
            <TextInput
              keyField="alternateCompany"
              formik={formik}
              required={false}
              label="Company"
              type="text"
              value={formik.values.alternateCompany}
              onChange={(e) => formik.setFieldValue("alternateCompany", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6}>
            <TextInput
              keyField="alternatePolicyNumber"
              formik={formik}
              required={false}
              label="Policy Number"
              type="text"
              value={formik.values.alternatePolicyNumber}
              onChange={(e) => formik.setFieldValue("alternatePolicyNumber", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6}>
            <TextInput
              keyField="alternateGroupNumber"
              formik={formik}
              required={false}
              label="Group Number"
              type="text"
              value={formik.values.alternateGroupNumber}
              onChange={(e) => formik.setFieldValue("alternateGroupNumber", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6}>
            <TextInput
              keyField="alternatePlanType"
              formik={formik}
              required={false}
              label="Plan Type"
              type="text"
              value={formik.values.alternatePlanType}
              onChange={(e) => formik.setFieldValue("alternatePlanType", e.target.value)}
            />
          </Col>
          <Col lg={4} md={6} className="modal_pro_file ">
            <DatePickerSelector
              keyField="alternateEffectiveDate"
              formik={formik}
              required={false}
              label="Effective Date"
              type="date"
              value={formik.values.alternateEffectiveDate}
              DatePickerSelector
              minDate={""}
              maxDate={moment()}
              onChange={(e) =>
                formik.setFieldValue("alternateEffectiveDate", moment(e).format("MM-DD-YYYY"))
              }
            />
          </Col>
        </Row>

        <div className="d-flex justify-content-center gap-3 mt-3">
          <button className="save_btn" type="button" onClick={()=>{patientDeatils?._id ? navigate("/clinic/patient-profile", { state: { patientData: patientDeatils?._id } }) : navigate("/clinic/patient-list");}}>Cancel</button>
          <button className="save_btn saving" type="submit">Save</button>
        </div>
      </Form>
    </div>
  );
};

export default AddInsurance;
